/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module AviProxyModule */

import { Component, Input } from '@angular/core';
import { PortalInfo } from 'ajs/modules/cportal';
import { L10nService } from '@vmw/ngx-vip';
import { ALBServicesConfig } from 'object-types';
import * as l10n from './avi-proxy.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *      Component used to represent system proxy.
 * @author Dnyaneshwar Jadhav
 */

@Component({
    selector: 'avi-proxy',
    templateUrl: './avi-proxy.component.html',
})

export class AviProxyComponent {
    /**
     * PortalInfo item.
     */
    @Input()
    public editable: PortalInfo;

    /**
     * Proxy Config object type.
     */
    public objectType = ALBServicesConfig;

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
